import React from "react";
import { Markdown } from "../lib/markdown";
import { Lightbulb, Network, ListChecks, Rocket, Link2, Sparkles } from "lucide-react";

export function WorksheetView({ data }) {
  if (!data) return null;
  return (
    <div className="grid grid-cols-1 md:grid-cols-12 gap-5" data-testid="worksheet-view">
      <Card className="md:col-span-12" accent icon={Sparkles} label="The Theme">
        <h2 className="text-2xl font-black tracking-tight" style={{ color: "#1E293B" }}>{data.theme}</h2>
      </Card>

      <Card className="md:col-span-8" icon={Lightbulb} label="Key Insights">
        <ul className="space-y-2.5">
          {(data.key_insights || []).map((x, i) => (
            <li key={i} className="flex gap-3 text-[15px] leading-relaxed" style={{ color: "#475569" }}>
              <span className="mt-2 w-1.5 h-1.5 rounded-full shrink-0" style={{ background: "#2563EB" }} />{x}
            </li>
          ))}
        </ul>
      </Card>

      <Card className="md:col-span-4" icon={Network} label="Connection Map">
        <p className="text-[15px] leading-relaxed" style={{ color: "#475569" }}>{data.connection_map}</p>
      </Card>

      <Card className="md:col-span-6" icon={ListChecks} label="Action Worksheet">
        <ul className="space-y-2.5">
          {(data.action_worksheet || []).map((x, i) => (
            <li key={i} className="flex gap-3 text-[15px] leading-relaxed" style={{ color: "#334155" }}>
              <span className="grid place-items-center w-5 h-5 rounded-md shrink-0 text-[11px] font-bold text-white" style={{ background: "#10B981" }}>{i + 1}</span>{x}
            </li>
          ))}
        </ul>
      </Card>

      <Card className="md:col-span-6" icon={Rocket} label="New Idea" tint="#ECFDF5">
        <Markdown text={data.new_idea || ""} />
      </Card>

      <Card className="md:col-span-12" icon={Link2} label="Related Questions">
        {(data.related_questions || []).length ? (
          <ul className="space-y-2">
            {data.related_questions.map((x, i) => (
              <li key={i} className="text-[15px]" style={{ color: "#475569" }}>• {x}</li>
            ))}
          </ul>
        ) : <p className="text-sm" style={{ color: "#94A3B8" }}>No other related questions in your library yet.</p>}
      </Card>
    </div>
  );
}

function Card({ children, className = "", icon: Icon, label, accent, tint }) {
  return (
    <div className={`rounded-2xl border p-6 shadow-sm ${className}`}
      style={{ borderColor: accent ? "#2563EB33" : "#CBD5E1", background: tint || "#fff", borderWidth: accent ? 2 : 1 }}>
      <div className="flex items-center gap-2 mb-3">
        <Icon size={16} color={accent ? "#2563EB" : "#64748B"} />
        <span className="text-xs font-bold uppercase tracking-[0.2em]" style={{ color: "#94A3B8" }}>{label}</span>
      </div>
      {children}
    </div>
  );
}
